var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { motion } from "framer-motion";
import ProductCard from './productCard';
export default function StripInfoProductCardContainer(props) {
    var fields = props.fields, isFlyoverSite = props.isFlyoverSite;
    var TitleTag = (fields.titleTag || 'h1');
    var cardVariants = {
        offscreen: {
            opacity: 0
        },
        onscreen: {
            opacity: 1
        }
    };
    var dataItems = props.children && props.children.filter(function (childItem) { return childItem.stripClassName == "sky23.productcard"; });
    return (React.createElement(motion.div, __assign({ initial: "offscreen", whileInView: "onscreen", viewport: { once: true, amount: 0.8 }, className: "strip sky23-info-product-cards container-fluid position-relative component container-sm-px-0"
            + (fields.textColour ? (" text-" + (isFlyoverSite ? "color-" : "") + fields.textColour) : "")
            + ((fields.topMargin) ? (" top-margin-" + fields.topMargin) : "")
            + ((fields.bottomMargin) ? (" bottom-margin-" + fields.bottomMargin) : "") }, (fields.jumplinkLabel ? { id: fields.jumplinkLabel.replace(/ /g, '') } : {})),
        React.createElement("div", { className: "row justify-content-center", itemScope: true, itemType: "https://schema.org/ItemList" },
            React.createElement("div", { className: "col col-md-11 col-auto" },
                React.createElement("div", { className: "row justify-content-center text-center" },
                    fields.icon && React.createElement("img", { src: fields.icon, className: "content-icon mb-3", title: fields.icon_title || fields.displayTitle, alt: fields.icon_description ? fields.icon_description : "", width: "66", itemProp: "image" }) || null,
                    fields.displayTitle &&
                        React.createElement(TitleTag, { className: "strip-title " + (fields.titleStyle ? fields.titleStyle : ""), itemProp: "name", dangerouslySetInnerHTML: { __html: fields.displayTitle } }) || null),
                React.createElement("div", { className: "g-3 cards-wrapper" },
                    React.createElement("div", { className: "list-cards"
                            + (fields.background ? (" bg-" + fields.background) : " no-bg")
                            + ((fields.topPadding) ? (" top-padding-" + fields.topPadding) : "")
                            + ((fields.bottomPadding) ? (" bottom-padding-" + fields.bottomPadding) : "") }, dataItems && dataItems.length > 0 && dataItems.map(function (item) {
                        return (React.createElement("div", { key: item.id, className: "card-wrapper" },
                            React.createElement(ProductCard, { item: item, isFlyoverSite: isFlyoverSite, cardsContentAlignment: fields.cardsContentAlignment })));
                    }))),
                fields.content && React.createElement("div", { className: "row justify-content-center text-center" },
                    React.createElement("div", { className: "strip-content", dangerouslySetInnerHTML: { __html: fields.content }, itemProp: "description" })) || null))));
}
